import { EnablePasskey } from '@bz/account';

export const route: RouteDefinition = {
  preload: () => {},

  info: {
    dialog: {
      get title() {
        return t('Enable passkey');
      },
      class: 'h-[550px]',
    },
  },
};

export default EnablePasskey;
